import styled from "styled-components";

export const SubmitReqRightColBtnsStyled = styled.div`
  display: flex;
  align-items: center;
  margin-top: 24px;

  font-size: 1.2em;
  font-weight: bold;

  .SubmitReqRightColBtnsStyled__btn {
    background-color: #ecedf0;
    border-radius: 12px;
    padding: 5px;
    min-width: 81px;
    height: 36px;
    color: #353a50;
    font-weight: inherit;
  }
  .SubmitReqRightColBtnsStyled__btn--yellow {
    flex-grow: 1;
    box-shadow: 0 3px 10px 0 rgba(255, 191, 29, 0.4);
    background-color: #ffbf1d;
    color: white;
    margin-right: 12px;
  }
`;
